module.exports = __webpack_public_path__ + "img/line-shape.226e9b77.png";